function MandatoryMarker({color}) {
    if(color) {
        return <span style={{ color: color, paddingLeft: "5px" }} title="Information obligatoire">!</span>
    }else
        return <span style={{ color: "red", paddingLeft: "5px" }} title="Information obligatoire!">*</span>
}

export default MandatoryMarker
